import { createContext } from "react";

export interface LocationDetailsType {
  property: string;
  revenueCenter: string;
  store: string;
  date: string;
}

interface InitialStateType {
  locationState: LocationDetailsType;
  locationSetState: any;
}

const LocationContext = createContext<InitialStateType[]>([]);

export default LocationContext;
